export default function Logo({ size = 44, showText = false, tone = "gold" }) {
  return (
    <div className="flex items-center gap-3" data-testid="brand-logo">
      <div
        className="flex items-center justify-center rounded-full ring-1 ring-amber-400/40 shadow-lg shadow-amber-500/10"
        style={{
          width: size + 6,
          height: size + 6,
          background:
            "radial-gradient(circle at 30% 25%, #ffffff 0%, #f4e9c5 45%, #d4b76a 100%)",
        }}
      >
        <img
          src="/brand/gsx-logo.jpeg"
          alt="Grupo Santo de Xadrez"
          width={size}
          height={size}
          style={{
            width: size,
            height: size,
            objectFit: "cover",
            mixBlendMode: "multiply",
          }}
          className="rounded-full"
        />
      </div>
      {showText && (
        <div className="leading-tight">
          <div className={`font-bold text-lg ${tone === "gold" ? "text-white" : "text-[#071A33]"}`}>
            Grupo Santo
          </div>
          <div className="text-xs tracking-widest uppercase gold-text">
            de Xadrez
          </div>
        </div>
      )}
    </div>
  );
}
